// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import useBuyingList from "@store/Framework/Common/Hooks/useBuyingList/useBuyingList";
import { CustomWidgetModule } from "@store/Framework/Types/types";
import SearchBox from "@store/Library/Components/Bunzl/Common/SearchBox";
import React from "react";

const BuyingListManagementSearch = () => {
    const { setBuyingListQuery, loading } = useBuyingList();
    return (
        <SearchBox
            onSearch={setBuyingListQuery}
            placeholder={translate("Filter by Buying List Name")}
            data-test-selector="buyingListManagementSearch_searchBox"
        />
    );
};

const widgetModule: CustomWidgetModule = {
    component: BuyingListManagementSearch,
    definition: {
        group: "Buying List",
    },
};

export default widgetModule;
